import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { QcsTypography } from '../common/basic/QcsTypography';

interface Props {
  stepNumber: number;
  totalSteps: number;
}

export const QcsMinimalistStepper: FC<Props> = ({ stepNumber, totalSteps }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3, maxWidth: 'md' }}>
      <QcsTypography variant="caption" sx={{ color: 'text.secondary', mb: 0.5, display: 'block' }}>
        {t('common.step')} {stepNumber} / {totalSteps} — {t(`invitation.create.step${stepNumber}`)}
      </QcsTypography>
      <Box sx={{ width: '100%', height: 3, bgcolor: 'divider', borderRadius: 1.5 }}>
        <Box
          sx={{
            width: `${(stepNumber / totalSteps) * 100}%`,
            height: '100%',
            bgcolor: 'primary.main',
            borderRadius: 1.5,
            transition: 'width 0.3s ease',
          }}
        />
      </Box>
    </Box>
  );
};
